import { __decorate } from "tslib";
import { Component } from 'decorators';
import template from './actionAgentErrorMsg.view.html';
let ActionAgentErrorMsgComponent = class ActionAgentErrorMsgComponent {
    constructor() {
        this.tooShortActionName = false;
    }
    //#endregion
    $onInit() {
        this.updateShortActionName(this.action);
    }
    $onChanges(changes) {
        if (changes.action && changes.action.currentValue) {
            this.updateShortActionName(changes.action.currentValue);
        }
    }
    updateShortActionName(action) {
        this.tooShortActionName = action.$title?.length < 3;
    }
};
ActionAgentErrorMsgComponent = __decorate([
    Component({
        template,
        bindings: {
            isValidActionName: '<',
            isUniqueTitle: '<',
            action: '<',
        },
        controllerAs: '$ctrl',
    })
], ActionAgentErrorMsgComponent);
export { ActionAgentErrorMsgComponent };
